import { summaryTableStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsSummaryTable";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

summaryTableStyles.title = {
    weight: "bold",
    size: "22px",
    as: "h2",
    css: css`
        @media print {
            font-size: 15px;
        }
        width: 100%;
        padding: 15px 0;
        margin-top: 10px;
        border-bottom: 1px solid ${getColor("common.border")};
    `,
};
